/**
 * Client contract for POST /api/requests/:id/save (#1501 Option B).
 * Mirrors server/entities/request-save.entity.ts — keep the two in sync.
 */

import type { TeamInformation } from './index';

export const AGGREGATE_FAMILY_KEYS = [
  'racks',
  'smallUps',
  'largeUps',
  'coolingSystems',
  'liquidCoolingCdus',
  'powerDistribution',
] as const;

export type AggregateFamilyKey = (typeof AGGREGATE_FAMILY_KEYS)[number];

export interface AggregateFamilyOps {
  create?: Array<{ clientKey: string } & Record<string, unknown>>;
  update?: Array<{ id: number } & Record<string, unknown>>;
  delete?: number[];
  /** Final order: persisted ids and clientKeys of creates (server resolves). */
  reorder?: Array<number | string>;
}

export type AggregateSavePayload = {
  request?: Record<string, unknown>;
  team?: TeamInformation[];
} & Partial<Record<AggregateFamilyKey, AggregateFamilyOps>>;

export interface AggregateSaveFailure {
  section: string;
  op: string;
  ref?: string | number;
  error: string;
}

export interface AggregateSaveResult {
  status: 'ok' | 'partial';
  applied: string[];
  failed: AggregateSaveFailure | null;
  skipped: string[];
  /** clientKey → created real id. */
  idMap: Record<string, number>;
  versionNumber: number | null;
  strippedFields: Record<string, string[]>;
  dealUnlinked: boolean;
}

/** The 404 body the server answers with while FEATURE_AGGREGATE_SAVE is off. */
export const AGGREGATE_SAVE_DISABLED_CODE = 'AGGREGATE_SAVE_DISABLED';
